//isolation du script
//Ne pas faire sinon le dataLayer n'a pas la bonne portée !!
//;(function() {
//------------------

//l'authentification du webservice ne fonctionne pas si l'on appelle les webservices à la racine sur /cmo/ et /cmmabn/
//eg: urlwebserviceCollecteAuthentifie="/fr/prjcliws.html"; ne marche pas sur CMO, il faut urlwebserviceCollecteAuthentifie="/cmo/fr/prjcliws.html";
//#region Selection banque
var root = "";
var testDomain = window.location.toString().split("/")[2];

if (window.location.toString().split("/")[3] == "cmo") {
  root = "/cmo";
} else if (window.location.toString().split("/")[3] == "cmmabn") {
  root = "/cmmabn";
} else if (window.location.toString().split("/")[3] == "cmne" && window.location.toString().split("/")[4] == "decouverte") {
  root = "/cmne/decouverte";
} else if (window.location.toString().split("/")[3] == "cmne") {
  root = "/cmne";
} else if (window.location.toString().split("/")[3] == "cmag") {
  root = "/cmag";
} else if (window.location.toString().split("/")[3] == "cmaf") {
  root = "/cmaf";
} else if (testDomain.substring(testDomain.length - 13, testDomain.length) == "mobile.cic.fr") {
  root = "/cic";
}

//#endregion

//var urlwebserviceCollecteAuthentifie=root+"/fr/prjcliwsauthentif.html";

if (root == "/cic") {
  var urlwebserviceCollecteAuthentifie = "/wsmb/fr/banque/prjcliwsauthentif.html"; //cas particulier pour l'apps mobile CIC
} else if (root == "/cmaf") {
  var urlwebserviceCollecteAuthentifie = root + "/fr/prjcliwsauthentif.html";
} else {
  var urlwebserviceCollecteAuthentifie = root + "/fr/banque/prjcliwsauthentif.html";
}

var urlwebserviceCollecteNonAuthentifie = root + "/fr/prjcliwsnonauthentif.html";
var urlwebserviceSauvegarde = root + "/fr/prjcliws_sauvegarde.html";
//var urlwebserviceRefusReexposition=root+"/fr/prjcliws_refus.html";
var urlwebserviceListe = root + "/fr/prjcliws_liste.html";

/*==========================================================================
Gestion des cookie et du LocalStorage
========================================================================== */
// !Attention! le localStorage ne marche pas dans le contexte Apps, ça fait planter le script
//#region Gestion cookies et localdata

function setCookie(name, value, days, path) {
  if (path == undefined) {
    path = "/";
  }
  var expires;
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toGMTString();
  } else {
    expires = "";
  }
  document.cookie = name + "=" + value + expires + "; path=" + path;
}
// ex : creation / ecriture cookie pour 1 journee : setCookie('myCookie', 'myValue', 1);

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
}
// lecture cookie : getCookie('myCookie');

function deleteCookie(name) {
  document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
}
// RAZ cookies : deleteCookie('myCookie');


function setLocalData(name, value, days) {
  // Le navigateur supporte le localStorage
  if (typeof window.localStorage == 'undefined') {
    setCookie(name, value, days);
  } else {
    localStorage.setItem(name, value);
  }
}

function getLocalData(name) {
  // Le navigateur supporte le localStorage
  var resultat;
  if (typeof window.localStorage == 'undefined') {
    resultat = getCookie(name);
  } else {
    resultat = localStorage.getItem(name);
  }
  return resultat;
}

function removeLocalData(name) {
  if (debugApps) {
    document.querySelector("section.PRJCLI").insertAdjacentHTML("beforebegin", "<p style=\"word-break: break-all; margin:10px\">removeLocalData</p>");
  }

  if (debugApps) {
    document.querySelector("section.PRJCLI").insertAdjacentHTML("beforebegin", "<p style=\"word-break: break-all; margin:10px\">typeof localStorage " + typeof window.localStorage + "</p>");
  }

  if (debugApps) {
    document.querySelector("section.PRJCLI").insertAdjacentHTML("beforebegin", "<p style=\"word-break: break-all; margin:10px\">localStorage.removeItem " + typeof window.localStorage.removeItem + "</p>");
  }

  // Le navigateur supporte le localStorage
  if (typeof window.localStorage === 'undefined') {
    deleteCookie(name);
  } else {
    window.localStorage.removeItem(name);
  }
}

//#endregion

/*==========================================================================
Extraction des paramétres d'URL
========================================================================== */
//#region Extraction des paramétres d'URL

function getVar(key, default_) {
  if (default_ == null) {
    default_ = 0;
  }
  key = key.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
  var regex = new RegExp("[\\?&#]" + key + "=([^&#]*)");
  var qs = regex.exec(window.location.href);
  if (qs == null) {
    return default_;
  } else {
    return qs[1];
  }
}

//#endregion
/*==========================================================================
==========================================================================*/

/*==========================================================================
Debug
========================================================================== */
//#region paramétres pour debug

// Fonction pour vérifier si l'URL de la page correspond à un environnement de développement
function isDevelopmentEnvironment() {
  const developmentDomains = ['tst-www.', 'sit-www', 'rqt-www', 'rqt-cl-www'];
  const currentDomain = window.location.hostname;

  return developmentDomains.some(domain => currentDomain.includes(domain));
}
//Passer à true pour avoir les messages de logs acvant le module dans les apps !NE PAS PASSER EN PROD AVEC VALEUR A TRUE!
var debugApps = false;
//Passer à true pour forcer les messages de console.log  !NE PAS PASSER EN PROD AVEC VALEUR A TRUE!
// Les messages console.log peuvent etre vu si le cookie consoleView est à 1 (ligne)
var consoleView = false;

// Vérification du cookie 'consoleView'
const consoleViewCookie = getCookie('consoleView');
let isConsoleView = consoleViewCookie === '1' || consoleView;

// Fonction de logging conditionnelle
function devlog(message) {
  if (isDevelopmentEnvironment() && isConsoleView) {
    console.log(message);
  } else if (consoleView) {
    console.log(message);
  }
}

//#endregion
/*==========================================================================
==========================================================================*/

/*
EB: \\Uf39-001.cm-cic.fr\gp_collecte_donnees_client_internet\Lot1B

Un module de collecte version non authentifie sera affiche pour les utilisateurs non logues.
- Pour un client reconnu (non authentifie mais qui s’est deja authentifie une fois sur le poste), le module de collecte version non authentifie appellera la fonction « Collecte » et devra forcer l’identification a la validation du formulaire de saisi.
- Pour un client non reconnu, le module de collecte version non authentifie n’appellera pas la fonction « Collecte » avant de s’afficher. A la validation du formulaire de saisie, il devra poser la question « Vous etes client ? » / « Avez-vous un contrat BAD ? »
o Si « oui » : le module debranchera sur la page d’identification avant de continuer l’enregistrement en PRJCLI.
o Si non : le module devra personnaliser la reponse pour les clients sans contrat BAD ou prospects et aucun enregistrement de projet/centre d’interet ne pourra etre realise.
Dans ce cadre de version non authentifiee, il faut realiser le developpement d’une page « fantome » internet qui sera appelee au succes de l’authentification. Cette page declenchera la fonction « Sauvegarde » du webservice et routera vers la page profil internet dans laquelle apparaitra le projet/centre d’interet nouvellement ajoute.

A voir:
- CI
- Que se passe t'il si déconnexion entre le moment on l'on a généré la collecte et le moment ou l'on sauveagarde
- afficher un message si + de 500 caractères de commentaires, ou empécher d'en rentrer plus
  */

/*==========================================================================
Initialisations et fonctions utilitaires
========================================================================== */
//#region init et focntions utilitaires


//on defini le datalayer au cas ou l'objet n'existe pas
if (typeof dataLayer == "undefined") {
  //devlog("dataLayer undefined");
  var dataLayer = [];
}

var cleanInput = function (texte) {
  if (texte !== "" && texte !== undefined && texte !== null) {
    //500 caractères max
    if (texte.length > 500) {
      texte = texte.substring(0, 499);
    }

    if (isNaN(texte)) {
      //on supprime tout ce qui n'est pas : un caractere (accentue ou non),@ chiffre -_ espace ' ’ saut de ligne . () ;
      //var res = texte.replace(/[^a-zÀ-ÿA-Za-o-o-ya-yoeŒ0-9@\.\-\_\s\'\’\)\(;,\?\!\n]/gi, "");
      //on encode
      var res = encodeURIComponent(texte);
      return res;
    } else {
      return texte;
    }
  } else {
    return texte;
  }
};

function isArray(x) {
  return x.constructor.toString().indexOf("Array") > -1;
}

Number.isInteger = Number.isInteger || function (value) {
  return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
};

//#endregion


/*==========================================================================
Fonction créant un message récapitulatif des projets dans le cas d'un formulaire de contact (conseiller ou général)
========================================================================== */
//#region generateMessage

function generateMessage(tabMessageProjets) {
  var message = "";
  console.log('prospect2');
  //tabMessageProjets.forEach(tabMessageProjets, function (index, obj) {
tabMessageProjets.forEach(function(obj, index) {
    console.log('prospect3');
    var niveau1 = obj["niveau1"];
    var niveau2 = obj["niveau2"];
    var dateEcheance = obj["dateEcheance"];
    var commentaire = obj["commentaire"];
    var montant = obj["montant"];
    switch (niveau1) {
      case 'FNCPJT':
        message = message + "\nFinancer un projet : loisir, mobilier, voyage…";
        break;
      case 'VEHACH':
        if (niveau2 && niveau2 == "VEHNEF") message = message + "\nAcheter un véhicule neuf";else if (niveau2 && niveau2 == "VEHOCS") message = message + "\nAcheter un véhicule d'occasion";else message = message + "\nAcheter un véhicule";
        break;
      case 'LOGACH':
        if (niveau2 && niveau2 == "LOGPLE") message = message + "\nAcheter ma résidence principale";else if (niveau2 && niveau2 == "LOGSCD") message = message + "\nAcheter une résidence secondaire";else message = message + "\nAcheter un résidence";
        break;
      case 'LOGTRV':
        if (niveau2 && niveau2 == "TRVRNO") message = message + "\nEffectuer des travaux de rénovation";else if (niveau2 && niveau2 == "TRVEQU") message = message + "\nEquiper et décorer un logement";else if (niveau2 && niveau2 == "TRVERG") message = message + "\nEffectuer des travaux d'économie d'énergie";else message = message + "\nAménager un logement";
        break;
      case 'LOGLCT':
        message = message + "\nEmménager dans un logement en location";
        break;
      case 'LOGLOU':
        message = message + "\nAcheter un bien immobilier pour le louer";
        break;
      case 'LOGVTE':
        message = message + "\nVendre un logement";
        break;
      case 'EFTETU':
        message = message + "\nFinancer les études de mes enfants";
        break;
      case 'VEHPRM':
        message = message + "\nFinancer un permis de conduire";
        break;
      case 'VIEACF':
        message = message + "\nEntrer dans la vie active";
        break;
      case 'ETSETS':
        if (niveau2 && niveau2 == "ETSCRE") message = message + "\nCréer une entrepriseVEHNEF";else if (niveau2 && niveau2 == "ETSREP") message = message + "\nReprendre une entreprise existante";else message = message + "\nCréer ou reprendre une entreprise";
        break;
      case 'ETSTRS':
        message = message + "\nTransmettre une entreprise";
        break;
      case 'DPARTI':
        message = message + "\nOrganiser un départ à la retraite";
        break;
      case 'RVNRGU':
        message = message + "\nPercevoir un complément de revenu";
        break;
      case 'FAMILL':
        message = message + "\nFamille";
        break;
      case 'FONCIE':
        message = message + "\nAchat de biens fonciers";
        break;
    }
    if (dateEcheance && dateEcheance != "") {
      message = message + "\nDate de réalisation : " + dateEcheance;
    }
    if (montant && montant != "") {
      message = message + "\nMontant : " + montant;
    }
    if (commentaire && commentaire != "") {
      message = message + "\n" + commentaire;
    }

    message = message + "\n";
  });

  if (message == "") {
    message = "Bonjour, je souhaiterais partager avec vous mes projets";
  } else {
    if (tabMessageProjets.length > 1) {
      message = "Bonjour, je souhaiterais partager avec vous les projets suivants :" + decodeURIComponent(message);
    } else {
      message = "Bonjour, je souhaiterais partager avec vous le projet suivant :" + decodeURIComponent(message);
    }
  }
  return message;
}

//#endregion

/*
########################
##### PRJCLI_Liste #####
########################
Permet de recuperer la liste des informations sur les projets ou centre d’interets collectes pour un tiers, avec la possibilite de filtrer sur un type de projet ou centre d’interet particulier.
Elle met a disposition des modules de collecte un service renvoyant les informations des projets ou centres d’interet d’un tiers deja saisis/collectes.
Elle est disponible uniquement pour les modules sur les pages des clients authentifies.
Cette methode renvoie :
- La liste des projets ou centres d’interet deja collectees (dans la limite de 20 occurrences)
- Ou, dans le cas d’une exception survenue pendant le traitement (arguments en entree invalides, erreur interne au serveur, …), un code retour et un libelle associe
=================
Donnees en entree
=================
Id || Identifiant unique du module PRJCli. Permet de cibler le module si plusieurs modules sont insérés dans une page || Obligatoire
Famille || Type de famille a renvoyer : projet ou centre d’interet || Valeurs possible : PJT/CIN || Obligatoire
Type || Type de projet / centre d’interet || Valeurs possible : AIM/BES/INT/OPM/ATR/PJT/PRO || Obligatoire
Recherche libelles || Recherche les libelles associes aux codes projets/CI || Facultatif, par defaut a « non »
  =================
Donnees en sortie
=================
## code-retour ##
Code retour (base sur la codification HTTP) de la requete.
Les codes principalement utilises sont :
- 200 (donnees du module renvoyees)
- 204 (controles KO - pas de donnees renvoyees, ex. refus de reexposition positionne)
- 401 (tiers non authentifie) 403 : tiers mineur
- 5XX (erreur serveur, ex. communication mainframe impossible)
  ## libelle-retour ##
Libelle associe au code retour (« OK », « Erreur de serveur interne », …)
  ## donnees-incompletes ##
La liste etant limitee a 20 occurrences, cette valeur indique si d’autres donnees existent en base.
Remarque : Le service n’est pas prevu pour obtenir la suite.
  ## liste-prjcin ##
Liste des projets / centre d’interets trouvees, 20 occurrences max
  ## famille ##
Type de famille (projet ou centre d’interet)
  # type #
Type de projet / centre d’interet (PJT / CIN)
  # type-libelle #
Libelle associe au type de projet
  # niveau1 #
Code niveau 1 du projet / centre d’interet
  # libelle-niveau1 #
Libelle associe au code niveau 1
  # niveau2 #
Code niveau 2 si existant du projet / centre d’interet
  # libelle-niveau2 #
Libelle associe au code niveau 2
  # date-echeance #
Date d’echeance, vide pour un CI
  # flag-projet-actif #
Valeur booleenne indiquant que le projet est actif ou inactif / clos, vide pour un CI.
*/
//#region PRJCLI_Liste


function PRJCLI_Liste(id, famille, type, RechecherLibelles) {
  //pointeur pour cibler le module PRJCLI
  var modulePRJCLI = document.getElementById(id);
  if (id === undefined || id === "") {
    if (document.getElementsByClassName("PRJCLI").length > 0) {
      modulePRJCLI = document.getElementsByClassName("PRJCLI")[0];
    } else {
      return "Erreur : parametre Id non déclaré";
    }
  }

  //obligatoire valeurs possible : PJT/CIN
  if (famille === undefined || famille === "" || famille != "PJT" && famille != "CIN") {
    return "Erreur : parametre 'famille' incorrect :" + famille;
  }
  //obligatoire valeurs possible : AIM/BES/INT/OPM/ATR/PJT/PRO
  if (type === undefined || type === "" || type != "AIM" && type != "BES" && type != "INT" && type != "OPM" && type != "ATR" && type != "PJT" && type != "PRO") {
    return "Erreur : parametre 'type' incorrect :" + type;
  }

  var requete = urlwebserviceListe + "?famille=" + famille + "&type=" + type + "&flag-rechercher-libelles" + RechecherLibelles;

  var xhr = new XMLHttpRequest();
  xhr.open('GET', requete, true);

  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4) {
      if (xhr.status === 200) {
        var retour = JSON.parse(xhr.responseText);
        devlog("425 PRJCLI_Liste - Données renvoyées par le Webservice :" + retour);
      } else {
        devlog('427 PRJCLI_Liste - @Error : ' + xhr.statusText);
        devlog('PRJCLI_Liste - @Status: ' + xhr.status);
        devlog('PRJCLI_Liste - @Status Text: ' + xhr.statusText);
      }

      devlog("PRJCLI_Liste - Complete :" + xhr.responseText);

      if (typeof PRJCLI_FinChargement === "function") {
        PRJCLI_FinChargement(); // Callback externe (optionnel)
      }
    }
  };

  xhr.send();
}

//#endregion

/*
########################
##### PRJCLI_Sauvegarde #####
########################
Permet de sauvegarder les donnees recoltees par un module de collecte pour un projet ou centre d’interet donne.
=================
Donnees en entree
=================
Id || Identifiant unique du module PRJCli. Permet de cibler le module si plusieurs modules sont insérés dans une page || Obligatoire
Famille || Type de famille a renvoyer : projet ou centre d’interet || Valeurs possible : PJT/CIN || Obligatoire
Type || Type de projet / centre d’interet || Valeurs possible : AIM/BES/INT/OPM/ATR/PJT/PRO || Obligatoire
Niveau 1 || Code niveau 1 du projet / centre d’interet || Obligatoire
Niveau 2 || Code niveau 2 du projet / centre d’interet || Facultatif
Date d'echeance || Date de realisation du projet || format JJ/MM/AAAA || Obligatoire si la famille est « Projet »
Commentaire || Commentaire du client || Facultatif
Device || Device d’origine (application ou web) || Obligatoire
Origine || Origine de la demande || Facultatif (non exploite)
Version || Version du module || Facultatif (non exploite)
Devise ||  Devise utilise pour le montant du projet || Facultatif
Montant || Montant du projet || Facultatif
  =================
Donnees en sortie
=================
## code-retour ##
Code retour (base sur la codification HTTP) de la requete.
Les codes principalement utilises sont :
- 200 (donnees du module renvoyees)
- 204 (controles KO - pas de donnees renvoyees, ex. refus de reexposition positionne)
- 401 (tiers non authentifie) 403 : tiers mineur
- 5XX (erreur serveur, ex. communication mainframe impossible)
  402 Status: TNA  | Tiers mineur Renvoyer vers messagerie sécurisée avec message type pré-renseigné
204 Status: TNA | Majeur sous tutelle Renvoyer vers messagerie sécurisée avec message type pré-renseigné
204 Status: TR | Tiers risqué (cotation risque) en fonction du projet Enregistrement du projet et affichage du module de restitution (avec avis de bonne fin)
204 Status: DA | Projet déjà enregistré (même date) On remplace le commentaire du projet qui existait auparavant
204 Status: DA | Projet unique (déjà un projet actif stock) Mise à jour du projet existant (date de réalisation et commentaire)
407 | Contrat B@D non détenteur du code fonction PCI  Renvoyer vers messagerie sécurisée avec message type pré-renseigné
406 | Périmètre non autorisé à PRJCLI BAD (CITDMG)  Renvoyer vers messagerie sécurisée avec message type pré-renseigné  Oui
204 Status: NHT | Module sur un projet non actif pour l'établissement (DRELADM) Renvoyer vers messagerie sécurisée avec message type pré-renseigné  Oui
200 Status: N/A | bonne fin

## libelle-retour ##
Libelle associe au code retour (« OK », « Erreur de serveur interne », …)
*/
//#region PRJCLI_Sauvegarde


function PRJCLI_Sauvegarde(id, famille, type, niveau1, niveau2, dateEcheance, commentaire, device, origine, version, devise, montant) {

  if (debugApps) {
    document.querySelector("section.PRJCLI").insertAdjacentHTML("beforebegin", "<p style=\"word-break: break-all; margin:10px; color:#30537e\">Start PRJCLI_Sauvegarde</p>");
  }

  //pointeur pour cibler le module PRJCLI
  var modulePRJCLI = document.getElementById(id);
  devlog("499 sauv-0", "id", id, "document.getElementsByClassName('PRJCLI').length", document.getElementsByClassName("PRJCLI").length, document.getElementsByClassName("PRJCLI")[0]);

  if (id === undefined || id === "") {
    if (document.getElementsByClassName("PRJCLI").length > 0) {
      modulePRJCLI = document.getElementsByClassName("PRJCLI")[0];
    } else {
      return "Erreur : parametre Id non déclaré";
    }
  }
  devlog("508 modulePRJCLI", modulePRJCLI);

  // Obligatoire valeurs possibles : PJT/CIN
  if (famille === undefined || famille === "" || famille !== "PJT" && famille !== "CIN") {
    return "Erreur : paramètre 'famille' incorrect :" + famille;
  }
  // Obligatoire valeurs possibles : AIM/BES/INT/OPM/ATR/PJT/PRO
  if (type === undefined || type === "" || type !== "AIM" && type !== "BES" && type !== "INT" && type !== "OPM" && type !== "ATR" && type !== "PJT" && type !== "PRO") {
    return "Erreur : paramètre 'type' incorrect :" + type;
  }
  // Obligatoire
  if (niveau1 === undefined || niveau1 === "" || niveau1 === "null") {
    return "Erreur : paramètre 'niveau1' incorrect :" + niveau1;
  }
  // Facultatif
  if (niveau2 === undefined || niveau2 === "null") {
    niveau2 = "";
  }
  // Obligatoire si la famille est « Projet »
  if (dateEcheance === undefined || dateEcheance === "" || dateEcheance === "null") {
    if (famille === "PJT") {
      return "Erreur : la date d'échéance n'est pas définie";
    } else {
      dateEcheance = "";
    }
  }
  // Facultatif
  if (commentaire === undefined || commentaire === "null") {
    commentaire = "";
  }
  if (device === undefined || device === "") {
    device = "C11"; // Obligatoire (valeur : C11) C11 = Desktop, C12 = Apps
  }
  // Facultatif
  if (origine === undefined || origine === "null") {
    origine = "";
  }
  // Facultatif
  if (version === undefined || version === "null") {
    version = "";
  }
  // Facultatif
  if (devise === undefined || devise === "null" || devise === "") {
    devise = "EUR";
  }
  // Facultatif
  if (montant === undefined || montant === "null") {
    montant = "";
  }

  // Le WS plante si on passe un montant vide
  var QSmontant = montant === "" ? "" : "&montant=" + montant;

  var requete = famille === "PJT" ? urlwebserviceSauvegarde + "?famille=" + famille + "&type=" + type + "&niveau1=" + niveau1 + "&niveau2=" + niveau2 + "&date=" + dateEcheance + "&commentaire=" + commentaire + "&device=" + device + "&origine=" + origine + "&version=" + version + QSmontant + "&devise=" + devise : urlwebserviceSauvegarde + "?famille=" + famille + "&type=" + type + "&niveau1=" + niveau1 + "&niveau2=" + niveau2 + "&device=" + device + "&origine=" + origine + "&version=" + version;

  if (debugApps) {
    document.querySelector("section.PRJCLI").insertAdjacentHTML("beforebegin", "<p style=\"word-break: break-all; margin:10px; color:#30537e\">PRJCLI_Sauvegarde requete : " + requete + " </p>");
  }

  // Test fx à retirer
  if (debugApps) {
    document.querySelector("section.PRJCLI").insertAdjacentHTML("beforebegin", "<p style=\"word-break: break-all; margin:10px\">Requete :" + requete + "</p>");
  }
  var xhr = new XMLHttpRequest();
  xhr.open('GET', requete, true);

  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4) {
      var modulePRJCLI = document.getElementById(id);

      if (modulePRJCLI) {
        var chargementElement = modulePRJCLI.querySelector(".chargement");
        var errorElement = modulePRJCLI.querySelector(".PRJCLI_error");

        if (chargementElement) {
          chargementElement.classList.add("masque");
        }

        if (xhr.status === 200) {
          var retour = JSON.parse(xhr.responseText);
          devlog("588 PRJCLI_Sauvegarde - Donnees renvoyees par le Webservice :" + retour);

          if (debugApps) {
            document.querySelector("section.PRJCLI").insertAdjacentHTML("beforebegin", "<p style=\"word-break: break-all; margin:10px; color:#30537e\">PRJCLI_Sauvegarde - Donnees renvoyees par le Webservice :" + JSON.stringify(retour) + "</p>");
          }

          // Temporaire: on parse le retour pour supprimer les "-" des noms de variables
          var strRetour = JSON.stringify(retour);
          strRetour = strRetour.replace(/-/g, "_");
          retour = JSON.parse(strRetour);
          //---------------------------------------------------------------------------
          /*
          5 : Un projet à déjà été ajouté pour cette date de réalisation
          402 Status: TNA  | Tiers mineur Renvoyer vers messagerie sécurisée avec message type pré-renseigné
          204 Status: TNA | Majeur sous tutelle Renvoyer vers messagerie sécurisée avec message type pré-renseigné
          204 Status: TR | Tiers risqué (cotation risque) en fonction du projet Enregistrement du projet et affichage du module de restitution (avec avis de bonne fin)
          204 Status: DA | Projet déjà enregistré (même date) On remplace le commentaire du projet qui existait auparavant
          204 Status: DA | Projet unique (déjà un projet actif stock) Mise à jour du projet existant (date de réalisation et commentaire)
          407 | Contrat B@D non détenteur du code fonction PCI  Renvoyer vers messagerie sécurisée avec message type pré-renseigné
          406 | Périmètre non autorisé à PRJCLI BAD (CITDMG)  Renvoyer vers messagerie sécurisée avec message type pré-renseigné  Oui
          204 Status: NHT | Module sur un projet non actif pour l'établissement (DRELADM) Renvoyer vers messagerie sécurisée avec message type pré-renseigné  Oui
          200 Status: N/A | bonne fin
          */

          if (retour.code_retour == "204" && retour.etat == "TNA" || retour.code_retour == "204" && retour.etat == "TR" || retour.code_retour == "204" && retour.etat == "NHT" || retour.code_retour == "402" && retour.etat == "TNA" || retour.code_retour == "406" || retour.code_retour == "407") {

            // le localStorage ne marche pas dans le contexte Apps, ça fait planter le script  C11 = Desktop, C12 = Apps)
            if (device == "C11") {
              //Renvoyer vers messagerie sécurisée avec message type pré-renseigné
              chargementElement.classList.add("masque");
              var temp = JSON.stringify(retour);
              //modulePRJCLI.find(".PRJCLI_error").append('<br />Retour : '+temp);

              //On récupére les Projets pour pré-remplir le message
              var tabMessageProjets = getLocalData('tabMessageProjets');
              if (tabMessageProjets != null) {
                tabMessageProjets = JSON.parse(tabMessageProjets);
              }

              //on vide le cookie et/ou le local Storage
              removeLocalData('tabMessageProjets');

              var message = generateMessage(tabMessageProjets);
              EspaceConseiller.OpenNewMessageForm("Mes projets", message);
            }
          } else if (retour.code_retour == "200" || retour.code_retour == "204" && retour.etat == "DA" || retour.code_retour == "5") {
            //sauvegarde OK ou Maj projet

            //on regarde si l'on est dans un cas de sauvegarde multiples (collecte multiple)
            if (modulePRJCLI.getAttribute("data-prjcli-sauvegardesRestantes")) {
              sauvegardesRestantes = modulePRJCLI.getAttribute("data-prjcli-sauvegardesRestantes");
            } else {
              sauvegardesRestantes = 1;
            }

            if (Number.isInteger(sauvegardesRestantes)) {
              //devlog("sauvegardesRestantes "+id+" " + sauvegardesRestantes);
              sauvegardesRestantes--;
              modulePRJCLI.setAttribute("data-prjcli-sauvegardesRestantes", sauvegardesRestantes);
            }

            if (sauvegardesRestantes === 0) {
              var collecte_multiple = false;
              //on regarde si l'on est en collecte multiple pour personnaliser le message de bonne fin
              if (modulePRJCLI.getAttribute("data-prjcli-multi") && modulePRJCLI.getAttribute("data-prjcli-multi") == 1) {
                collecte_multiple = true;
              }

              if (modulePRJCLI.getAttribute("data-prjcli-famille") == "PJT") {
                chargementElement.classList.add("masque");
                modulePRJCLI.querySelector(".PRJCLI_collecte").classList.remove("masque");

                if (collecte_multiple) {
                  modulePRJCLI.querySelector(".PRJCLI_PJT_MULTI_success").classList.remove("masque");
                } else {
                  modulePRJCLI.querySelector(".PRJCLI_PJT_success").classList.remove("masque");
                  modulePRJCLI.querySelector(".prjcli-entete").classList.add("masque");
                  modulePRJCLI.querySelector(".prjcli-entete-success").classList.remove("masque");
                }
              } else {
                chargementElement.classList.add("masque");
                modulePRJCLI.querySelector(".PRJCLI_collecte").classList.remove("masque");

                if (collecte_multiple) {
                  modulePRJCLI.querySelector(".PRJCLI_PJT_MULTI_success").classList.remove("masque");
                } else {
                  modulePRJCLI.querySelector(".PRJCLI_PJT_success").classList.remove("masque");
                }
              }

              // le localStorage ne marche pas dans le contexte Apps, ça fait planter le script  C11 = Desktop, C12 = Apps)
              if (device == "C11") {
                //on vide les cookies/localdata de messages
                removeLocalData('tabMessageProjets');
              }
            }

            if (typeof dataLayer != 'undefined') {
              dataLayer.push({
                'event': 'customEvent',
                'customCategory': 'Module',
                'customAction': 'ImpressionReelle',
                'customLabel': 'PRJCLI_Confirmation#' + famille + '#' + niveau1,
                'customValue': undefined
              });
            }
            if (typeof trackEvent != 'undefined') {
              trackEvent({
                category: 'Module',
                action: 'ImpressionReelle',
                label: 'PRJCLI_Confirmation#' + famille + '#' + niveau1
              });
            }

            devlog("702 datalayer PRJCLI_Confirmation", dataLayer);
          } else {
            //Erreur de sauvegarde
            modulePRJCLI.querySelector(".chargement").classList.add("masque");
            //modulePRJCLI.find(".PRJCLI_error").append('Requete : '+ requete);
            //modulePRJCLI.find(".PRJCLI_error").append('<br />@Error : '+retour.code_retour);
            //modulePRJCLI.find(".PRJCLI_error").append('<br />Libelle  : '+retour.libelle_retour);
            var temp = JSON.stringify(retour);
            //modulePRJCLI.find(".PRJCLI_error").append('<br />Retour : '+temp);
            modulePRJCLI.querySelector(".PRJCLI_collecte").classList.remove("masque");
            modulePRJCLI.querySelector(".PRJCLI_error").classList.remove("masque");

            devlog('714 PRJCLI_Sauvegarde - @Error code retour :' + retour.code_retour);

            if (debugApps) {
              document.querySelector("section.PRJCLI").insertAdjacentHTML("beforebegin", "<p style=\"word-break: break-all; margin:10px; color:#30537e\">PRJCLI_Sauvegarde - @Error code retour : " + retour.code_retour + "</p>");
            }
          }
        } else {
          devlog('721 PRJCLI_Sauvegarde - @Error : ' + xhr.statusText);
          devlog('PRJCLI_Sauvegarde - @Status: ' + xhr.status);
          devlog('PRJCLI_Sauvegarde - @Status Text: ' + xhr.statusText);

          if (debugApps) {
            document.querySelector("section.PRJCLI").insertAdjacentHTML("beforebegin", "<p style=\"word-break: break-all; margin:10px; color:#30537e\">PRJCLI_Sauvegarde - @Error: " + xhr.statusText + "<br />" + xhr.status + "<br />" + xhr.statusText + "</p>");
          }

          if (errorElement) {
            errorElement.classList.remove("masque");
          }
        }

        devlog("734 PRJCLI_Sauvegarde - Complete " + xhr.responseText + " " + xhr.status);

        if (typeof PRJCLI_FinChargement === "function") {
          PRJCLI_FinChargement(); // Callback externe (optionnel)
        }
      }
    }
  };

  xhr.send();

  return "ok";
}

//#endregion

/*
########################
##### PRJCLI_Collecte (Authentifie ou non) #####
########################
Cette methode permet de collecter les donnees par defaut pour les modules de collecte, pour un type de projet ou centre d’interet donne (ex : titre, illustration, …).
Elle permer de vérifier le périmètre fonctionnel et que la nature de projet/centre d’intérêt est active. Elle renvoie les données par défaut de la nature de projet/centre d’intérêt à collecter.
Le service de collecte verifie aussi la limite d’exposition parametree pour chaque type de projet, ainsi que le refus d’exposition des clients.
En mode authentifié elle permet aussi de recuperer des donnees deja collectees (ex : date de realisation d’un projet) pour un tiers donne.
  =================
Donnees en entree fonction
=================
Id || Identifiant unique du module PRJCli. Permet de cibler le module si plusieurs modules sont insérés dans une page || Obligatoire
modeCollecte || Mode de collecte || CollecteNonAuthentifie ou CollecteAuthentifie || Obligatoire
  =================
Donnees en entree WS
=================
Famille || Type de famille a renvoyer : projet ou centre d’interet || Valeurs possible : PJT/CIN || Obligatoire
Type || Type de projet / centre d’interet || Valeurs possible : AIM/BES/INT/OPM/ATR/PJT/PRO || Obligatoire
Niveau 1 || Code niveau 1 du projet / centre d’interet || Obligatoire
Famille / Type et Niveau 1 peuvent également être envoyés sous forme de tableau. Si le projet/CI du premier élément du tableau n'est pas collectable, on passe au suivant
Niveau 2 || Code niveau 2 du projet / centre d’interet || Facultatif
Device || Device d’origine (application ou web) || Obligatoire  C11 = Desktop, C12 = Apps
Origine || Origine de la demande || Facultatif (non exploite)
Version || Version du module || Facultatif (non exploite)
Langue || Code langue du client connecte  || Facultatif
Pays || Code pays du client connecte  || Facultatif
Ignorer la sur-exposition || Flag permettant d’ignorer la surexposition d’un tiers  || Facultatif
  ActionSiProjetExistant || Action a effectuer si un projet est déjà collecté || Valeurs possible : Afficher/Collecter || Facultatif (Pas de nouvelles collecte par défaut)
  =================
Donnees en sortie WS
=================
## code-retour ##
Code retour (base sur la codification HTTP) de la requete.
Les codes principalement utilises sont :
- 200 (donnees du module renvoyees)
- 204 (controles KO - pas de donnees renvoyees, ex. refus de reexposition positionne)
- 401 (tiers non authentifie) 403 : tiers mineur
- 5XX (erreur serveur, ex. communication mainframe impossible)
  ## libelle-retour ##
Libelle associe au code retour (« OK », « Erreur de serveur interne », …)
  ## titre ##
Titre par defaut du module de collecte.
  ## question ##
Question par defaut du module de collecte. Uniquement si presence de niveau 2 dans le referentiel etablissement.
  ## liste-reponses ##
Liste des reponses par defaut du module de collecte. Uniquement si presence de niveau 2 dans le referentiel etablissement.
  ## liste-reponses-libelle ##
Libellé des liste des reponses par defaut du module de collecte. Uniquement si presence de niveau 2 dans le referentiel etablissement.

## url-illustration ##
URL de l’image d’illustration par defaut du module de collecte.
  ---------------------
Si client Authentifié
---------------------
## etat##
Etat des donnees retournees :
- DNA (Device non autorisé)
- DA (Déclaré actif) Projet/centre d’interet present en table et actif (ex : projet non traite)
- DNA (Déclaré non actif)  Projet/centre d’interet present en table mais desactive (ex : projet traite)
- DNT (Données non trouvées) Projet/centre d’interet  non present en table, non declare
- RES (Refus d'exposition spécifique) Refus d’exposition pour ce projet/centre d’interet
- REG (Refus d'exposition global) Refus d’exposition global, valable pour tous les modules de collecte
- LED (Limite d'exposition dépassée) Limite d’exposition sur la periode parametree depassee pour ce projet/centre d’interet
- TR (Tiers risqué) Le tiers est risque (cotation risque trop elevee) selon le parametrage defini pour ce projet/centre d’interet
- DC (Données confidentielles) Projet/centre d’interet confidentiel, pas de donnees en retour, hors donnees par defaut
  ## date-echeance ##
Dans le cas d’un projet uniquement, la date de realisation associee.
  ## commentaire ##
Commentaire client associe.
  ## origine ##
Origine de la demande : conseiller ou client
  ## nombre-refus-reexpo ##
Nombre de refus de reexposition demandes par le client sur une periode de 1 mois glissant.
Par exemple, si la requete a la web-methode « Collecte » est effectuee le 30 avril, la periode s’etends du 30 mars au 30 avril (1 mois glissant), on renverra donc 3 refus de reexposition.
  ## date-derniere-expo ##
Date de la derniere requete a la web-methode « Collecte » pour ce projet/centre d’interet specifique.
  */
//#region PRJCLI_Collecte

function PRJCLI_Collecte(id, modeCollecte) {

  if (debugApps) {
    document.querySelector("section.PRJCLI").insertAdjacentHTML("beforebegin", "<p style=\"word-break: break-all; margin:10px\">Start Collecte</p>");
  }

  var isOk;
  var nb_ProjetCI_a_charger = 0;
  var nb_ProjetCI_a_collecter = 0;
  var sauvegardesRestantes = 0;
  var afficherModule = 0;

  var famille = "";
  var type = "";
  var niveau1 = "";
  var niveau2 = "";
  var device = "";
  var origine = "";
  var version = "";
  var langue = "";
  var pays = "";
  var banque = "";
  var guichet = "";
  var urlIdentification = "";
  var urlAuthentificationForte = "";
  var client = false;
  var ignorerSurexpo = "";
  var requete;

  //pointeur pour cibler le module PRJCLI
  var modulePRJCLI = document.getElementById(id);
  if (id === undefined || id === "") {
    if (document.getElementsByClassName("PRJCLI").length > 0) {
      modulePRJCLI = document.getElementsByClassName("PRJCLI")[0];
    } else {
      return "Erreur : parametre Id non déclaré";
    }
  }

  if (modulePRJCLI.getAttribute("data-prjcli-famille") !== undefined) {
    famille = modulePRJCLI.getAttribute("data-prjcli-famille");
  }
  //obligatoire valeurs possible : AIM/BES/INT/OPM/ATR/PJT/PRO
  /*  if(modulePRJCLI.getAttribute("data-prjcli-type") !== undefined)
      type = modulePRJCLI.getAttribute("data-prjcli-type");
    //obligatoire
    if(modulePRJCLI.getAttribute("data-prjcli-niveau1") !== undefined)
      niveau1 = modulePRJCLI.getAttribute("data-prjcli-niveau1");*/
  //facultatif
  if (modulePRJCLI.getAttribute("data-prjcli-device") !== undefined) {
    device = modulePRJCLI.getAttribute("data-prjcli-device");
  }

  //facultatif
  if (modulePRJCLI.getAttribute("data-prjcli-origine") !== undefined) {
    origine = modulePRJCLI.getAttribute("data-prjcli-origine");
  }
  //facultatif
  if (modulePRJCLI.getAttribute("data-prjcli-version") !== undefined) {
    version = modulePRJCLI.getAttribute("data-prjcli-version");
  }
  //facultatif
  if (modulePRJCLI.getAttribute("data-prjcli-langue") !== undefined) {
    langue = modulePRJCLI.getAttribute("data-prjcli-langue");
  }
  //facultatif
  if (modulePRJCLI.getAttribute("data-prjcli-pays") !== undefined) {
    pays = modulePRJCLI.getAttribute("data-prjcli-pays");
  }
  if (modulePRJCLI.getAttribute("data-prjcli-banque") !== undefined) {
    banque = modulePRJCLI.getAttribute("data-prjcli-banque");
  }
  if (modulePRJCLI.getAttribute("data-prjcli-guichet") !== undefined) {
    guichet = modulePRJCLI.getAttribute("data-prjcli-guichet");
  }
  if (modulePRJCLI.getAttribute("data-prjcli-urlIdentification") !== undefined) {
    urlIdentification = modulePRJCLI.getAttribute("data-prjcli-urlIdentification");
  }
  if (modulePRJCLI.getAttribute("data-prjcli-urlAuthentificationForte") !== undefined) {
    urlAuthentificationForte = modulePRJCLI.getAttribute("data-prjcli-urlAuthentificationForte");
  }
  //facultatif
  if (modulePRJCLI.getAttribute("data-prjcli-is") !== undefined) {
    ignorerSurexpo = modulePRJCLI.getAttribute("data-prjcli-is");
  }

  if (modulePRJCLI.getAttribute("data-prjcli-status") !== undefined && modulePRJCLI.getAttribute("data-prjcli-status") == "c") {
    client = true;
  }

  if (modeCollecte === undefined || modeCollecte === "") {
    modeCollecte = "CollecteNonAuthentifie";
  }
  //obligatoire valeurs possible : PJT/CIN
  if (famille === undefined || famille === "" || famille != "PJT" && famille != "CIN") {
    return "Erreur : parametre 'famille' incorrect :" + famille;
  }
  if (device === undefined || device === "") {
    device = "C11"; //Obligatoire (valeur : C11=web)
  }

  //test fx a retirer
  //device="C11";

  //facultatif
  if (origine === undefined) origine = "";
  //facultatif
  if (version === undefined) version = "";
  //facultatif
  if (langue === undefined) langue = "fr";
  //facultatif
  if (pays === undefined) pays = "fr";
  //facultatif
  if (ignorerSurexpo === undefined || ignorerSurexpo != "O" && ignorerSurexpo != "N") ignorerSurexpo = "N";

  //ignorerSurexpo = "O";

  devlog('PRJCLI_Collecte');

  //si client non reconnu ou prospect
  var rdClientRadios = document.querySelectorAll('[name="rdClient"]');
  var actionButton = document.getElementById(id).querySelector(".action button");
  rdClientRadios.forEach(function (rdClientRadio) {
    rdClientRadio.addEventListener('change', function () {
      // Vérifiez la valeur du bouton radio sélectionné
      if (rdClientRadio.value === 'client') {
        actionButton.innerHTML = modulePRJCLI.getAttribute("data-prjcli-txtBoutonPersoNonAuthentifie");
      } else if (rdClientRadio.value === 'prospect') {
        actionButton.innerHTML = modulePRJCLI.getAttribute("data-prjcli-txtBoutonPerso");
      }
    });
  });

  // Pour chaque projet / CI
  //modulePRJCLI.getElementsByTagName("fieldset").each(function(){
  var fieldsets = modulePRJCLI.getElementsByTagName("fieldset");
  var nb_ProjetCI_a_charger = 0;
  for (i = 0; i < fieldsets.length; i++) {
    nb_ProjetCI_a_charger++;
    type = fieldsets[i].getAttribute("data-prjcli-type");
    niveau1 = fieldsets[i].getAttribute("data-prjcli-niveau1");
    devlog("971 index ", i, "type ", type, "niveau1 ", niveau1);
    var requete;
    if (modeCollecte == "CollecteAuthentifie") {
      requete = urlwebserviceCollecteAuthentifie + "?famille=" + famille + "&type=" + type + "&niveau1=" + niveau1 + "&niveau2=" + niveau2 + "&device=" + device + "&origine=" + origine + "&langue=" + langue + "&pays=" + pays + "&ignorer_surexpo=" + ignorerSurexpo;
    } else {
      requete = urlwebserviceCollecteNonAuthentifie + "?famille=" + famille + "&type=" + type + "&niveau1=" + niveau1 + "&niveau2=" + niveau2 + "&device=" + device + "&origine=" + origine + "&langue=" + langue + "&pays=" + pays + "&banque=" + banque + "&guichet=" + guichet + "&ignorer_surexpo=" + ignorerSurexpo;
    }

    devlog('979 PRJCLI_Collecte - requete : ' + requete);

    if (debugApps) {
      document.querySelector("section.PRJCLI").insertAdjacentHTML("beforebegin", "<p style=\"word-break: break-all; margin:10px\">Requete :" + requete + "</p>");
    }

    if (modeCollecte == "CollecteAuthentifie" || modeCollecte == "CollecteNonAuthentifie" && banque != "" && guichet != "") {
      var currentFieldset = fieldsets[i];
      var xhr = new XMLHttpRequest();
      xhr.open('GET', requete, true);
      xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 300) {
          var retour = JSON.parse(xhr.responseText);
          var fieldsetPci = currentFieldset;
          var modulePRJCLI = currentFieldset.closest(".PRJCLI");

          // Code à exécuter en cas de succès (équivalent du bloc success)
          nb_ProjetCI_a_charger--;

          //Temporaire on parse le retour pour supprimer les "-" des noms de variables
          // var strRetour = JSON.stringify(retour);
          // strRetour = strRetour.replace(/\-/g,"\_");
          // retour = JSON.parse(strRetour);
          //---------------------------------------------------------------------------

          //on test si le code retour est ok pour collecter (code retour 200 ou projet créé par le conseiller)
          // if(retour.code_retour != "200" && !(retour.code_retour == 204 && retour.etat == "DC"))

          if (retour.code_retour != "200" && !(retour.code_retour == 204 && retour.etat == "DC")) {
            //################# la collecte n'est pas possible ##############################
            devlog("1009 PRJCLI_Collecte - " + fieldsetPci.getAttribute("data-prjcli-type") + " " + fieldsetPci.getAttribute("data-prjcli-niveau1") + " : " + "Collecte impossible, code retour :" + retour.code_retour);

            if (debugApps) {
              document.querySelector("section.PRJCLI").insertAdjacentHTML("beforebegin", "<p style=\"word-break: break-all; margin:10px\">Requete :" + "Retour PRJCLI_Collecte - " + fieldsetPci.getAttribute("data-prjcli-type") + " " + fieldsetPci.getAttribute("data-prjcli-niveau1") + " : " + "Collecte impossible, code retour :" + retour.code_retour + " | " + retour.libelle_retour + "</p>");
            }

            //on masque le fieldset
            fieldsetPci.classList.add("masque");

            //on cache la mention relative aux commentaires
            if (document.querySelector("#commentaires-prjcli")) {
              document.querySelector("#commentaires-prjcli").classList.add("masque");
            }

            if (typeof dataLayer != 'undefined') {
              dataLayer.push({
                'event': 'customEvent',
                'customCategory': 'Module',
                'customAction': 'ImpressionReelle',
                'customLabel': 'PRJCLI_CollecteImpossible#' + retour.code_retour + '#' + fieldsetPci.getAttribute("data-prjcli-type") + '#' + fieldsetPci.getAttribute("data-prjcli-niveau1"),
                'customValue': undefined
              });
            }

            if (typeof trackEvent != 'undefined') {
              trackEvent({
                category: 'Module',
                action: 'ImpressionReelle',
                label: 'PRJCLI_CollecteImpossible#' + retour.code_retour + '#' + fieldsetPci.getAttribute("data-prjcli-type") + '#' + fieldsetPci.getAttribute("data-prjcli-niveau1")
              });
            }
            devlog("datalayer ImpressionReelle PRJCLI_CollecteImpossible", dataLayer);
          } else {
            //################# la collecte est possible ##############################
            if (debugApps) {
              document.querySelector("section.PRJCLI").insertAdjacentHTML("beforebegin", "<p style=\"word-break: break-all; margin:10px\">Collecte possible - " + fieldsetPci.getAttribute("data-prjcli-type") + " " + fieldsetPci.getAttribute("data-prjcli-niveau1") + " : " + "Collecte possible, code retour :" + retour.code_retour + "</p>");
            }
            // Remonter le tag "impression réelle" au moment où le client voit réellement le module
            var prjcliModuleAtteint = false;

            function isModuleAtteint() {
              var prjcliWindowBottomY = window.scrollY + window.innerHeight,
                  prjcliModuleOffsetTop = modulePRJCLI.offsetTop;

              // Impression réelle si l'utilisateur atteint le module au scroll
              if (!prjcliModuleAtteint && prjcliWindowBottomY > prjcliModuleOffsetTop) {
                prjcliModuleAtteint = true;

                //on retire l'event listener qui n'est plus nécessaire
                window.removeEventListener('scroll', isModuleAtteint);
                // Collecte
                // DataLayer impression réelle
                if (typeof dataLayer != 'undefined') {
                  dataLayer.push({
                    'event': 'customEvent',
                    'customCategory': 'Module',
                    'customAction': 'ImpressionReelle',
                    'customLabel': 'PRJCLI_Collecte#' + fieldsetPci.getAttribute("data-prjcli-type") + '#' + fieldsetPci.getAttribute("data-prjcli-niveau1"),
                    'customValue': undefined
                  });
                }

                if (typeof trackEvent != 'undefined') {
                  trackEvent({
                    category: 'Module',
                    action: 'ImpressionReelle',
                    label: 'PRJCLI_Collecte#' + fieldsetPci.getAttribute("data-prjcli-type") + '#' + fieldsetPci.getAttribute("data-prjcli-niveau1")
                  });
                }
                devlog("datalayer ImpressionReelle PRJCLI_Collecte", dataLayer);
              }
            }

            window.addEventListener('scroll', isModuleAtteint);

            // Au chargement du module, trigger le scroll 1 fois au cas ou l'utilisateur aurait déjà passé en dessous du module
            //var event = new Event('scroll');
            //window.dispatchEvent(event);
            //FX : fait planter IE !!!
            isModuleAtteint();

            devlog("1090 Lien partager un nouveau projet mis en place");
            document.querySelector(".cc a.partager_nouveau_projet").addEventListener("click", function () {
              // devlog("Partager un nouveau projet");

              // Ajout du dataLayer.push
              if (typeof dataLayer != 'undefined') {
                dataLayer.push({
                  'event': 'customEvent',
                  'customCategory': 'Module',
                  'customAction': 'Clic',
                  'customLabel': 'PRJCLI_PartagerNouveauProjet#' + fieldsetPci.getAttribute("data-prjcli-type") + '#' + fieldsetPci.getAttribute("data-prjcli-niveau1"),
                  'customValue': undefined
                });
              }

              if (typeof trackEvent != 'undefined') {
                trackEvent({
                  category: 'Module',
                  action: 'Clic',
                  label: 'PRJCLI_PartagerNouveauProjet#' + fieldsetPci.getAttribute("data-prjcli-type") + '#' + fieldsetPci.getAttribute("data-prjcli-niveau1")
                });
              }
              //devlog("datalayer Clic PRJCLI_PartagerNouveauProjet", dataLayer);
            });

            //Si le projet/CI est déja actif
            if (retour.etat == "DA") {
              if (typeof dataLayer != 'undefined') {
                dataLayer.push({
                  'event': 'customEvent',
                  'customCategory': 'Module',
                  'customAction': 'ImpressionReelle',
                  'customLabel': 'PRJCLI_DejaActif#' + fieldsetPci.getAttribute("data-prjcli-type") + '#' + fieldsetPci.getAttribute("data-prjcli-niveau1"),
                  'customValue': undefined
                });
              }

              if (typeof trackEvent != 'undefined') {
                trackEvent({
                  category: 'Module',
                  action: 'ImpressionReelle',
                  label: 'PRJCLI_DejaActif#' + fieldsetPci.getAttribute("data-prjcli-type") + '#' + fieldsetPci.getAttribute("data-prjcli-niveau1")
                });
              }
              devlog("1134 datalayer ImpressionReelle PRJCLI_DejaActif", dataLayer);

              //on masque le fieldset de collecte
              fieldsetPci.classList.add("masque");

              //cas d'une collecte simple (unique), on restitue les informations du projet existant
              if (modulePRJCLI.getAttribute("data-prjcli-multi") == 0) {
                afficherModule = 1;
                //on modifie le titre
                modulePRJCLI.querySelector("h2").innerHTML = "Votre projet";

                //Si on a un libellé de niveau 2, c'est lui que l'on affiche comme titre
                var restitutionAction = modulePRJCLI.querySelector(".PRJCLI_PJT_restitution .action");

                if (retour.libelle_niveau2 !== "" && retour.libelle_niveau2 != "null" && retour.libelle_niveau2 !== null) {
                  restitutionAction.insertAdjacentHTML('beforebegin', "<div class='infos'><h3>" + retour.libelle_niveau2 + "</h3></div>");
                } else {
                  //sinon on affiche le titre
                  restitutionAction.insertAdjacentHTML('beforebegin', "<div class='infos'><h3>" + retour.titre + "</h3></div>");
                }
                devlog("1151 restitutionAction infos");
                if (modulePRJCLI.getAttribute("data-prjcli-famille") == "PJT") {
                  restitutionAction.insertAdjacentHTML('beforebegin', "<p class='details'></p>");

                  devlog("1155 restitutionAction details");
                  if (retour.date_realisation !== "" && retour.date_realisation != "null" && retour.date_realisation !== null && retour.date_realisation != "01/01/0001") {
                    //on formate la date de restitution pour afficher "mois/année"
                    var MoisRealisation = "";
                    var AnneeRealisation = "";

                    var tab_date_realisation = retour.date_realisation.split("/");
                    if (tab_date_realisation != "") switch (tab_date_realisation[1]) {
                      case "01":
                        MoisRealisation = "Janvier";
                        break;
                      case "02":
                        MoisRealisation = "Février";
                        break;
                      case "03":
                        MoisRealisation = "Mars";
                        break;
                      case "04":
                        MoisRealisation = "Avril";
                        break;
                      case "05":
                        MoisRealisation = "Mai";
                        break;
                      case "06":
                        MoisRealisation = "Juin";
                        break;
                      case "07":
                        MoisRealisation = "Juillet";
                        break;
                      case "08":
                        MoisRealisation = "Août";
                        break;
                      case "09":
                        MoisRealisation = "Septembre";
                        break;
                      case "10":
                        MoisRealisation = "Octobre";
                        break;
                      case "11":
                        MoisRealisation = "Novembre";
                        break;
                      case "12":
                        MoisRealisation = "Décembre";
                        break;
                    }
                    AnneeRealisation = tab_date_realisation[2];
                    //on test qu'AnneeRealisation est une annee supérieure a 2018
                    var regex = RegExp(/^(2019|2[0-9][0-9][0-9])?$/g);
                    if (!regex.test(AnneeRealisation)) {
                      AnneeRealisation = "";
                    }

                    /*
                    if(MoisRealisation != "" && AnneeRealisation != "")
                      modulePRJCLI.find(".PRJCLI_PJT_restitution .action").before("<p><strong>Date de réalisation</strong>&nbsp;:&nbsp;"+MoisRealisation+" "+AnneeRealisation+"</p>");
                    else
                      modulePRJCLI.find(".PRJCLI_PJT_restitution .action").before("<p><strong>Date de réalisation</strong>&nbsp;:&nbsp;"+retour.date_realisation+"</p>");
                    */
                    var restitutionDetails = modulePRJCLI.querySelector(".PRJCLI_PJT_restitution .details");
                    if (MoisRealisation != "" && AnneeRealisation != "") {
                      restitutionDetails.innerHTML += "<span><strong>Date&nbsp;de&nbsp;réalisation</strong>&nbsp;: " + MoisRealisation + "&nbsp;" + AnneeRealisation + "</span>";
                    } else {
                      restitutionDetails.innerHTML += "<span><strong>Date&nbsp;de&nbsp;réalisation</strong>&nbsp;: " + retour.date_realisation + "</span>";
                    }
                  }

                  devlog("1221 restitutionAction date");
                  /*
                  if(retour.commentaire !== "" && retour.commentaire != "null" && retour.commentaire !== null)
                    modulePRJCLI.find(".PRJCLI_PJT_restitution .action").before("<p><strong>Commentaire</strong>&nbsp;:&nbsp;"+retour.commentaire+"</p>");
                  */

                  if (retour.commentaire !== "" && retour.commentaire != "null" && retour.commentaire !== null) {
                    restitutionDetails.innerHTML += "<span><strong>Commentaire</strong>&nbsp;: " + retour.commentaire + "</span>";
                  }
                }
                if (retour.origine == "CDC") {
                  // modulePRJCLI.find(".PRJCLI_PJT_restitution .action").prepend("<span class=\"conseiller\">(Ajouté par votre conseiller)</p>");
                  modulePRJCLI.querySelector(".PRJCLI_PJT_restitution h3").insertAdjacentHTML('afterend', "<span class=\"conseiller\"> (Ajouté par votre conseiller)</span>");;
                }

                modulePRJCLI.querySelector(".prjcli-entete").classList.add("masque");
                // Sélectionne tous les éléments avec la classe '.PRJCLI_PJT_restitution' à partir de l'élément parent modulePRJCLI
                var restitutionsElements = modulePRJCLI.querySelectorAll('.PRJCLI_PJT_restitution');

                // Parcourt tous les éléments sélectionnés
                restitutionsElements.forEach(function(element) {
                  // Supprime la classe 'masque' de chaque élément
                  element.classList.remove('masque');
                });
                devlog("1246 .PRJCLI_PJT_restitution remove masque after");
              }
            } else {
              //Si le projet/CI est non déclaré, non actif ou non traité
              /*
              dataLayer.push({
                'event' : 'customEvent',
                'customCategory' : 'Module',
                'customAction' : 'ImpressionReelle',
                'customLabel' : 'PRJCLI_Collecte#'+fieldsetPci.data("prjcli-type")+'#'+fieldsetPci.data('prjcli-niveau1'),
                'customValue' : undefined
              });
              */
              //devlog("dataLayer PRJCLI_Collecte#"+fieldsetPci.data("prjcli-type")+'#'+fieldsetPci.data('prjcli-niveau1'), dataLayer);
              //on souhaite collecter ce projet / CI
              nb_ProjetCI_a_collecter++;
              afficherModule = 1;

              //Si c'est un projet
              if (modulePRJCLI.getAttribute("data-prjcli-famille") == "PJT") {
                //si l'on a pas de titre de Projet personnalisé, on utilise celui renvoyé par le WS
                if (fieldsetPci.querySelector("legend").innerHTML === "") {
                  fieldsetPci.querySelector("legend").innerHTML = retour.titre;
                  if (fieldsetPci.querySelector(".label-projet")) {
                    fieldsetPci.querySelector(".label-projet").innerHTML = retour.titre;
                  }
                }

                if (retour.url_illustration != "" && retour.url_illustration != null) {
                  //temporaire on remets les "-" dans l'adresse des images
                  tab_url_illustration = retour.url_illustration.split("/");
                  tab_url_illustration[2] = tab_url_illustration[2].replace(/\_/g, "\-");
                  url_illustration = tab_url_illustration.join("/");
                  //-------------------------------------------------
                  //fieldsetPci.append("<img src=\""+url_illustration+"\" alt=\"\" />");
                }

                //Affichage de la date de réalisation -------------------
                //génération des années possible en fonction de la date
                var d = new Date();
                var annee = d.getFullYear();

                //on vérifie le format et qu'on est bien au minimum en 2020
                if (annee === undefined || !Number.isInteger(annee) || annee < 2020) {
                  annee = 2020;
                }

                //on génére les options du champ année
                var selectElement = fieldsetPci.querySelector("[name='AnneeRealisation']");
                for (var i = 0; i < 5; i++) {
                  var optionElement = document.createElement("option");
                  optionElement.value = annee;
                  optionElement.textContent = annee;

                  selectElement.appendChild(optionElement);

                  annee++;
                }

                //par défaut, on sélectionne le mois suivant
                var actual_month = d.getMonth(); //return a Number, from 0 to 11, representing the month
                var next_month = actual_month + 1;

                //si l'on est le mois de décembre (actual_month -> 0 to 11)
                if (actual_month == 11) {
                  fieldsetPci.querySelector("[name='MoisRealisation']").options[0].selected = true; //on sélectionne janvier
                  fieldsetPci.querySelector("[name='AnneeRealisation']").options[1].selected = true; //on sélectionne l'année suivante
                } else {
                  //sinon, on sélectionne le mois suivant
                  fieldsetPci.querySelector("[name='MoisRealisation']").options[next_month].selected = true;
                }

                fieldsetPci.querySelector("[data-prjcli-form='DateRealisation']").classList.remove("masque");
                //-----------------------------------------------------------

                //Affichage de la question de niveau2 si nécessaire ---------
                if (retour.question !== "" && retour.question !== undefined && retour.question !== null && retour.liste_reponses !== undefined && retour.liste_reponses.length > 0) {
                  //si l'on a pas question de niveau 2 personnalisé, on utilise celui renvoyé par le WS
                  if (fieldsetPci.querySelector("[data-prjcli-form='Qniv2Label']").innerHTML == "") {
                    fieldsetPci.querySelector("[data-prjcli-form='Qniv2Label']").innerHTML = retour.question + " <span class=\"mandatory\">*</span>";
                  }

                  var selectElement = fieldsetPci.querySelector("[name='RepQniv2']");
                  for (var i = 0; i < retour.liste_reponses.length; i++) {
                    var optionElement = document.createElement("option");
                    optionElement.value = retour.liste_reponses[i];
                    optionElement.textContent = retour.liste_reponses_libelle[i];

                    selectElement.appendChild(optionElement);
                  }

                  fieldsetPci.querySelector("[data-prjcli-form='Qniv2']").classList.remove("masque");
                }
                //-----------------------------------------------------------
                fieldsetPci.querySelector("[data-prjcli-form='commentaire']").classList.remove("masque");
              } else {
                //si c'est un CI
                //si l'on a pas de titre de CI personnalisé, on utilise le type
                if (fieldsetPci.querySelector("legend").innerHTML === "") {
                  var titre = "vos centres d'intérêt";
                  switch (fieldsetPci.getAttribute("data-prjcli-type")) {
                    case "AIM":
                      titre = "Vous aimez";
                      break;
                    case "BES":
                      titre = "Vos besoins professionnels";
                      break;
                    case "INT":
                      titre = "Ces sujets vous intéressent";
                      break;
                    case "OPM":
                      titre = "Vous voulez optimiser";
                      break;
                    case "ATR":
                      titre = "Autres projets";
                      break;
                    case "PJT":
                      titre = "Projets personnels";
                      break;
                    case "PRO":
                      titre = "Projets professionnels";
                      break;
                  }
                  fieldsetPci.querySelector("legend").innerHTML = titre;
                  fieldsetPci.querySelector("[data-prjcli-form='CI'] label").innerHTML = retour.titre;
                  fieldsetPci.querySelector("[data-prjcli-form='CI']").classList.remove("masque");
                }
              }
              //------------------------------------------------------------------------------------
            }
          } //FIN - la collecte est possible

          devlog("1369 PRJCLI_Collecte - Données renvoyées par le Webservice :", retour);

          // Reste du code à exécuter dans le bloc complete
          handleComplete(retour, fieldsetPci, modulePRJCLI);
        } else {
          // Code à exécuter en cas d'erreur (équivalent du bloc error)
          isConsoleView && console.error("1358 Erreur lors de la requête :", xhr.status, xhr.statusText);
          //var fieldsetPci = fieldsets[i];
          //var modulePRJCLI = fieldsetPci.closest(".PRJCLI");
          modulePRJCLI.querySelector(".chargement").classList.add("masque");
          modulePRJCLI.querySelector(".PRJCLI_error").classList.remove("masque");

          if (debugApps) {
            document.querySelector("section.PRJCLI").insertAdjacentHTML("beforebegin", "<p style=\"word-break: break-all; margin:10px\">PRJCLI_Collecte - @Error : " + error.message + "</p>");
          }

          // Appeler la fonction complete avec un objet d'erreur
          handleComplete({ error: true }, currentFieldset, currentFieldset.closest(".PRJCLI"));
        }
      };
      xhr.onerror = function () {
        // Code à exécuter en cas d'erreur réseau (équivalent du bloc error)
        console.error("Erreur réseau lors de la requête.");

        // Appeler la fonction complete avec un objet d'erreur
        handleComplete({ error: true }, currentFieldset, currentFieldset.closest(".PRJCLI"));
      };

      xhr.send();
    } //fin du if(modeCollecte == "CollecteAuthentifie")
  } //fin du foreach fieldset

  function handleComplete(retour, fieldsetPci, modulePRJCLI) {
    /*var fieldsetPci = currentFieldset;
    var modulePRJCLI = currentFieldset.closest(".PRJCLI");*/
    devlog("1404 fieldsetPci", fieldsetPci);
    devlog("modulePRJCLI", modulePRJCLI);

    // Temporarily parse the response to remove "-" from variable names
    var strRetour = JSON.stringify(retour);
    strRetour = strRetour.replace(/\-/g, "\_");
    retour = JSON.parse(strRetour);
    //---------------------------------------------------------------------------

    //on regarde si toutes les requêttes de récupération de question sont terminée
    if (nb_ProjetCI_a_charger == 0) {
      if (nb_ProjetCI_a_collecter == 0) {
        modulePRJCLI.querySelector(".PRJCLI_collecte form").classList.add("masque");
        //on cache la mention relative aux commentaires
        if (document.getElementById("commentaires-prjcli")) {
          document.getElementById("commentaires-prjcli").classList.add("masque");
        }
      } else {
        //on a des Projets/CI a collecter, on définni les actions a effectuer en cas de soumission du formulaire
        var fieldsetOk = modulePRJCLI.querySelectorAll("fieldset:not(.masque)");
        var nbFieldsetOk = fieldsetOk.length;
        var tabCollecteNonAuthentifiee = []; //tableau pour stoquer les projets a collecter pour stockage Cookie/LocalData et utilisation dans un parcours non authentifié
        var tabMessageProjets = []; //tableau pour stoquer les projets a collecter pour stockage Cookie/LocalData et restitution dans un message au conseiller si collecte impossible

        // ----------------------------------------------------------------------------
        // Soumission du formulaire de collecte ---------------------------------------
        // ----------------------------------------------------------------------------
        //modulePRJCLI.find("form").off("submit").on("submit", function(){
        //modulePRJCLI.find("[type='submit']").off("click").on("click", function(){
        modulePRJCLI.querySelector("[type='submit']").addEventListener("click", function (event) {
          event.preventDefault(); // Empêche le comportement par défaut du bouton "submit"
          event.stopPropagation(); // Empêche la propagation de l'événement de cli
          if (debugApps) {
            document.querySelector("section.PRJCLI").insertAdjacentHTML("beforebegin", "<p style=\"word-break: break-all; margin:10px; color:#8f4c7e\">Soumission formulaire</p>");
          }
          devlog('1439 click soumission formulaire');
          //$(this) correspond au formulaire
          var d = new Date();
          var annee = d.getFullYear();
          //on vérifie le format et qu'on est bien au minimum en 2024
          if (annee === undefined || !Number.isInteger(annee) || annee < 2024) {
            annee = 2024;
          }
          var actual_year = annee;
          //par défaut, on sélectionne le mois suivant
          var actual_month = d.getMonth(); //return a Number, from 0 to 11, representing the month

          //si on a plusieurs fieldset on vérifie qu'il y en a bien un de séléctionné
          if (fieldsetOk.length > 1) {
            var noProjectSel = true;
            fieldsetsOk.forEach(function (fieldset) {
              if (fieldset.querySelector("[name='PRJ']").checked) {
                noProjectSel = false;
                return false; //on termine le each
              }
            });
            if (noProjectSel) {
              alert("Vous devez sélectionner au moins un projet à transmettre");
            }
          }

          // Pour chaque fieldset non masqué du formulaire on lance une requête au webservice
          fieldsetOk.forEach(function (fieldset, index) {
            //Si c'est un projet
            if (famille == "PJT") {
              //Si on est en collecte multiple on regarde si le projet est coché, sinon on ajoute le projet par défaut
              var isProjectSelected = nbFieldsetOk === 1 || nbFieldsetOk > 1 && fieldset.querySelector("[name='PRJ']").checked;
              if (isProjectSelected) {
                //on vérifie qu la date est bien au minimum dans un mois
                var anneeSel = cleanInput(fieldset.querySelector("[name='AnneeRealisation']").value);
                var moisSel = cleanInput(fieldset.querySelector("[name='MoisRealisation']").value);
                if (anneeSel == actual_year) {

                  // if(parseInt($(this).find("[name='MoisRealisation'] option:selected").index()) <= actual_month)
                  // {
                  //  alert("Vous devez choisir une date supérieure au mois en cours.");
                  //  return false;
                  // }
                  var selectMois = fieldset.querySelector("[name='MoisRealisation']");
                  devlog("fieldset 1483", index, "selectMois.selectedIndex", selectMois.selectedIndex, "niveau1", niveau1);
                  if (parseInt(selectMois.selectedIndex) < actual_month) {
                    alert("Vous devez choisir une date supérieure ou égale au mois en cours.");
                    return false;
                  }
                }

                //formatage de la date  au format AAAA-MM-JJ
                var dateEcheance = anneeSel + "-" + moisSel + "-01";
                devlog("dateEcheance " + dateEcheance);
                var niveau1 = "";
                if (fieldset.getAttribute("data-prjcli-niveau1") != null && fieldset.getAttribute("data-prjcli-niveau1") != undefined) {
                  niveau1 = cleanInput(fieldset.getAttribute("data-prjcli-niveau1"));
                }
                var niveau2 = "";
                if (fieldset.querySelector("[name='RepQniv2']").value != null && fieldset.querySelector("[name='RepQniv2']").value != undefined) {
                  niveau2 = cleanInput(fieldset.querySelector("[name='RepQniv2']").value);
                }
                var commentaire = "";
                if (fieldset.querySelector("[name='commentaire']").value != null && fieldset.querySelector("[name='commentaire']").value != undefined) {
                  commentaire = cleanInput(fieldset.querySelector("[name='commentaire']").value);
                }
                var devise = "";
                var montant = "";
                devlog("1507 ", niveau1, niveau2, commentaire);
                if (debugApps) {
                  document.querySelector("section.PRJCLI").insertAdjacentHTML("beforebegin", "<p style=\"word-break: break-all; margin:10px; color:#8f4c7e\">Before test authentification" + niveau1 + " " + niveau2 + " " + commentaire + "</p>");
                  document.querySelector("section.PRJCLI").insertAdjacentHTML("beforebegin", "<p style=\"word-break: break-all; margin:10px; color:#8f4c7e\">Before test authentification" + device + "</p>");
                }
                //si l'on est en mode collecte Authentifiée est que l'on est toujours authentifié
                devlog('14151396 TEST AVANT CL');
                //if(device == "C12" || (modeCollecte == "CollecteAuthentifie" && getCookie("IdSes") != null && getCookie("SessionStart") != null && getCookie("SessionTimeout") != null))
                // retrait du getCookie IdDes car il est en http only et on ne peut donc pas le lire
                if (device == "C12" || modeCollecte == "CollecteAuthentifie" && getCookie("SessionStart") != null && getCookie("SessionTimeout") != null) {
                  devlog('TEST APRES CL');
                  devlog("1518 PRJCLI_Sauvegarde(" + id + "," + famille + "," + type + "," + niveau1 + "," + niveau2 + "," + dateEcheance + "," + commentaire + "," + device + "," + origine + "," + version + "," + devise + "," + montant + ");");
                  if (debugApps) {
                    document.querySelector("section.PRJCLI").insertAdjacentHTML("beforebegin", "<p style=\"word-break: break-all; margin:10px; color:#8f4c7e\">PRJCLI_Sauvegarde(" + id + "," + famille + "," + type + "," + niveau1 + "," + niveau2 + "," + dateEcheance + "," + commentaire + "," + device + "," + origine + "," + version + "," + devise + "," + montant + ");" + "</p>");
                  }
                  modulePRJCLI.querySelector(".PRJCLI_collecte form").classList.add("masque");
                  modulePRJCLI.querySelector(".PRJCLI_collecte form").insertAdjacentHTML('beforebegin', modulePRJCLI.querySelector(".chargement").outerHTML);
                  modulePRJCLI.querySelector(".PRJCLI_collecte .chargement").classList.remove("masque");

                  if (typeof dataLayer != 'undefined') {
                    dataLayer.push({
                      'event': 'customEvent',
                      'customCategory': 'Module',
                      'customAction': 'Clic',
                      'customLabel': 'PRJCLI_Transmettre#' + famille + '#' + niveau1,
                      'customValue': undefined
                    });
                  }

                  if (typeof trackEvent != 'undefined') {
                    trackEvent({
                      category: 'Module',
                      action: 'Clic',
                      label: 'PRJCLI_Transmettre#' + famille + '#' + niveau1
                    });
                  }
                  devlog("1543 datalayer Clic PRJCLI_Transmettre", dataLayer);

                  const isOk = PRJCLI_Sauvegarde(id, famille, type, niveau1, niveau2, dateEcheance, commentaire, device, origine, version, devise, montant);
                  sauvegardesRestantes++;
                  modulePRJCLI.setAttribute("data-prjcliSauvegardesRestantes", sauvegardesRestantes);

                  if (isOk != "ok") {
                    modulePRJCLI.querySelector(".PRJCLI_collecte form").classList.add("masque");
                    modulePRJCLI.querySelector(".PRJCLI_error").insertAdjacentHTML('beforeend', '@Error : ' + isOk);
                    modulePRJCLI.querySelector(".PRJCLI_error").classList.remove("masque");
                    devlog("1553 PRJCLI_Collecte - Nok :" + isOk);
                    return;
                  }

                  //On stoque les projets dans un  Cookie/LocalData pour restitution dans un message au conseiller si la collecte impossible
                  var messagetoSave = {
                    "niveau1": niveau1,
                    "niveau2": niveau2,
                    "dateEcheance": "01-" + moisSel + "-" + anneeSel,
                    "commentaire": commentaire,
                    "montant": montant
                  };
                  tabMessageProjets.push(messagetoSave);
                  devlog("1566 tabMessageProjets", tabMessageProjets);

                  // le localStorage ne marche pas dans le contexte Apps, ça fait planter le script  C11 = Desktop, C12 = Apps)
                  if (device == "C11") {
                    if (index == nbFieldsetOk - 1) setLocalData("tabMessageProjets", JSON.stringify(tabMessageProjets));
                  }
                } else {
                  devlog("1573 non authentifie");
                  //collecte non authentifiée
                  //on force l'authentification avec passage des infos du formulaire dans un cookie de session

                  //Ancienne version, avec passage de tous les éléments du formulaire dans l'URL :> ne supporte pas la sauvegarde multiple
                  //var redirection = urlIdentification + "?redirect_url="+ urlAuthentificationForte +"&redirect_query_string=cible%3D"+window.location.pathname+"%26id%3D"+id+"%26famille%3D"+famille+"%26type%3D"+type+"%26niveau1%3D"+niveau1+"%26niveau2%3D"+niveau2+"%26dateEcheance%3D"+dateEcheance+"%26commentaire%3D"+commentaire+"%26device%3D"+device+"%26origine%3D"+origine+"%26version%3D"+version+"%26devise%3D"+devise+"%26montant%3D"+montant;
                  //window.location.href = redirection;

                  //On créée un objet avec toutes les informations pour le stoquer dans un cookie ou le localstorage
                  var toSave = {
                    "cible": window.location.pathname,
                    "id": id,
                    "famille": famille,
                    "type": type,
                    "niveau1": niveau1,
                    "niveau2": niveau2,
                    "dateEcheance": dateEcheance,
                    "commentaire": commentaire,
                    "device": device,
                    "origine": origine,
                    "version": version,
                    "devise": devise,
                    "montant": montant
                  };
                  tabCollecteNonAuthentifiee.push(toSave);
                  devlog("1581 tabCollecteNonAuthentifiee", tabCollecteNonAuthentifiee);

                  //On stoque les projets dans un  Cookie/LocalData pour restitution dans un message au conseiller si la collecte impossible
                  var messagetoSave = {
                    "niveau1": niveau1,
                    "niveau2": niveau2,
                    "dateEcheance": "01-" + moisSel + "-" + anneeSel,
                    "commentaire": commentaire,
                    "montant": montant
                  };
                  tabMessageProjets.push(messagetoSave);
                  devlog("1609 tabMessageProjets", tabMessageProjets);
                  // si tous les projets ont étés traités
                  if (index == nbFieldsetOk - 1) {
                    //si c'est un client, on force l'authentification
                    if (client || fieldset.querySelector("[name='rdClient']:checked").value == "client") {
                      if (typeof dataLayer != 'undefined') {
                        dataLayer.push({
                          'event': 'customEvent',
                          'customCategory': 'Module',
                          'customAction': 'Clic',
                          'customLabel': 'PRJCLI_Non_Authentifie_indentification_Transmission',
                          'customValue': undefined
                        });
                      }

                      if (typeof trackEvent != 'undefined') {
                        trackEvent({
                          category: 'Module',
                          action: 'Clic',
                          label: 'PRJCLI_Non_Authentifie_indentification_Transmission'
                        });
                      }

                      // le localStorage ne marche pas dans le contexte Apps, ça fait planter le script  C11 = Desktop, C12 = Apps)
                      //bon normallement on ne rentre pas dans cette boucle en contexte Apps puisque l'on est forcément authentifié (mais une protection supplémentaire ne fait jamais de mal)
                      if (device == "C11") {

                        setLocalData("tabCollecteNonAuthentifiee", JSON.stringify(tabCollecteNonAuthentifiee));
                        setLocalData("tabMessageProjets", JSON.stringify(tabMessageProjets));
                        /*
                        localStorage.setItem("tabCollecteNonAuthentifiee", JSON.stringify(tabCollecteNonAuthentifiee));
                        localStorage.setItem("tabMessageProjets", JSON.stringify(tabMessageProjets));
                        */
                      }
                      devlog("1643 setLocalData", JSON.stringify(tabCollecteNonAuthentifiee), JSON.stringify(tabMessageProjets));
                      var redirection = urlIdentification + "?redirect_url=" + urlAuthentificationForte + "&redirect_query_string=cible%3D" + window.location.pathname + "%26save%3D1";
                      window.location.href = redirection;
                    } else {
                      //sinon on envoi un message de contact
                      // formulaire de contact a définir dans le modèle ACE ex https://www.cic.fr/fr/banques/particuliers/nous-contacter/votre-demande-en-ligne.html?rdConcerne=un%20autre%20renseignement&txtMessage_dnfta=
                      // https://www.creditmutuel.fr/fr/contact/nous-contacter.html
                      // pour cmne voire avec jerome.vastra@cmne.fr pour qu'il donne un accès direct https://www.creditmutuel.fr/cmne/fr/contact.html#

                      if (typeof dataLayer != 'undefined') {
                        dataLayer.push({
                          'event': 'customEvent',
                          'customCategory': 'Module',
                          'customAction': 'Clic',
                          'customLabel': 'PRJCLI_Non_Authentifie_Contact_Conseiller',
                          'customValue': undefined
                        });
                      }

                      if (typeof trackEvent != 'undefined') {
                        trackEvent({
                          category: 'Module',
                          action: 'Clic',
                          label: 'PRJCLI_Non_Authentifie_Contact_Conseiller'
                        });
                      }
                      var formContact = modulePRJCLI.getAttribute("data-prjcli-contact");
                      console.log('prcjli prosp');
                      console.log(tabMessageProjets);
                      var message = escape(generateMessage(tabMessageProjets)); //bien utiliser escape() et pas encodeURIComponent, sinon les accents bugs
                      //window.location.href = formContact + message;
                      window.location.href = formContact;
                    }
                  }
                }
              }
            } else {
              //Si c'est un CI
              //si le CI est coché
              if (fieldset.querySelector("[name='CI']").checked) {

                devlog("1681 PRJCLI_Sauvegarde(" + id + "," + famille + "," + type + "," + niveau1 + ",,,," + device + "," + origine + "," + version + ",,);");
                modulePRJCLI.querySelector(".PRJCLI_collecte form").classList.add("masque");
                modulePRJCLI.querySelector(".PRJCLI_collecte form").insertAdjacentHTML('beforebegin', modulePRJCLI.querySelector(".chargement").outerHTML);
                modulePRJCLI.querySelector(".PRJCLI_collecte .chargement").classList.remove("masque");

                isOk = PRJCLI_Sauvegarde(id, famille, type, niveau1, "", "", "", device, origine, version, "", "");
                sauvegardesRestantes++;
                modulePRJCLI.setAttribute("data-prjcliSauvegardesRestantes", sauvegardesRestantes);

                if (isOk != "ok") {
                  modulePRJCLI.querySelector(".PRJCLI_collecte form").classList.add("masque");
                  modulePRJCLI.querySelector(".PRJCLI_error").insertAdjacentHTML('beforeend', '@Error : ' + isOk);
                  modulePRJCLI.querySelector(".PRJCLI_error").classList.remove("masque");
                  devlog("1694 PRJCLI_Sauvegarde - Nok :" + isOk);

                  if (debugApps) {
                    document.querySelector("section.PRJCLI").insertAdjacentHTML("beforebegin", "<p style=\"word-break: break-all; margin:10px\">PRJCLI_Sauvegarde - Nok :" + isOk + "</p>");
                  }
                }
              }
            }
          });

          return false;
        });
        // FIN - Soumission du formulaire de collecte ------------------------------------
        //--------------------------------------------------------------------------------

        //----------------------------------------------------------------------------------
        //Afficher / Cacher le détail du projet dans le cas de la collecte multiple --------
        //----------------------------------------------------------------------------------
        if (famille == "PJT" && modulePRJCLI.getAttribute("data-prjcli-multi") === "1") {
          fieldsetOk.forEach(function (fieldset) {
            var cible = fieldset;
            fieldset.querySelector("[name='PRJ']").addEventListener("change", function () {
              if (this.checked) {
                this.setAttribute("data-collapsed", "no").setAttribute("aria-expanded", "true").setAttribute("aria-selected", "true");
                cible.querySelector(".prjcli-detail").setAttribute("aria-hidden", "false").setAttribute("tabindex", "0");
              } else {
                this.setAttribute("data-collapsed", "yes").setAttribute("aria-expanded", "false").setAttribute("aria-expanded", "false").setAttribute("aria-expanded", "false");
                cible.querySelector(".prjcli-detail").setAttribute("aria-hidden", "true").setAttribute("tabindex", "-1");
              }
            });
          });
        }

        //----------------------------------------------------------------------------------
        //Gestion d'exposition ---------------------------------------------------------------
        //----------------------------------------------------------------------------------
        //modulePRJCLI.find("[data-prjcli='RefusReexpo']").removeClass("masque");
        //bouton qui affiche la zone de gestion d'exposition

        //premiere version : on demandait confirmation du refus de reexposition
        /*
        modulePRJCLI.find("[data-prjcli='RefusReexpo'] button").off('click').on("click", function(){
          modulePRJCLI.find("[data-prjcli='RefusReexpo'] button").addClass("masque");
          modulePRJCLI.find(".PRJCLI_collecte form").addClass("masque");
          modulePRJCLI.find(".PRJCLI_collecte > [class^='PRJCLI']").addClass("masque");
          modulePRJCLI.find("[data-prjcli='GestionExposition']").removeClass("masque");
          return false;
        });*/

        //bouton de sortie de la zone de gestion d'exposition global
        /*
        modulePRJCLI.find("[data-prjcli='AnnulerRefusExpo']").off('click').on("click", function(){
          modulePRJCLI.find("[data-prjcli='RefusReexpo'] button").removeClass("masque");
          if(retour.responseJSON.etat == "DA")
            modulePRJCLI.find(".PRJCLI_PJT_restitution").removeClass("masque");
          else
            modulePRJCLI.find(".PRJCLI_collecte form").removeClass("masque");
          modulePRJCLI.find("[data-prjcli='GestionExpositionGlobal']").addClass("masque");
          return false;
        });*/

        //bouton qui lance le refus d'exposition
        /*
        modulePRJCLI.find("[data-prjcli='RefusReexpo']").off('click').on("click", function(){
        var refusExpoRestans=0;*/
        //devlog("Refus reexpo");

        //modulePRJCLI.find("[data-prjcli='GestionExposition']").addClass("masque");
        //modulePRJCLI.find(".PRJCLI_collecte form").before(modulePRJCLI.find(".chargement").prop('outerHTML'));
        //modulePRJCLI.find(".PRJCLI_collecte .chargement").removeClass("masque");

        //Si le client a déjà refusé 3 modules dans le mois, on affiche les boutons de refus global d'exposition
        /*
        if(retour.responseJSON.nombre_refus_reexpo >= 3)
        {
          modulePRJCLI.find("[data-prjcli='RefusReexpo'] button").addClass("masque");
          modulePRJCLI.find(".PRJCLI_collecte form").addClass("masque");
          modulePRJCLI.find(".PRJCLI_collecte > [class^='PRJCLI']").addClass("masque");
          modulePRJCLI.find("[data-prjcli='GestionExpositionGlobal']").removeClass("masque");
            //bouton qui lance le refus d'exposition GLOBAL
          modulePRJCLI.find("[data-prjcli='RefusGlobal']").off('click').on("click", function(){
            devlog("PRJCLI_RefusExposition("+id+",\"G\");");
            //on cache le module de collecte
            modulePRJCLI.find(".PRJCLI_collecte").addClass("masque");
            // modulePRJCLI.find("[data-prjcli='GestionExposition']").addClass("masque");
            // modulePRJCLI.find("[data-prjcli='RefusGlobal'] button").addClass("masque");
            // modulePRJCLI.find(".PRJCLI_collecte form").before(modulePRJCLI.find(".chargement").prop('outerHTML'));
            // modulePRJCLI.find(".PRJCLI_collecte .chargement").removeClass("masque");
              dataLayer.push({
              'event' : 'customEvent',
              'customCategory' : 'Module',
              'customAction' : 'Clic',
              'customLabel' : 'PRJCLI_RefusGlobal',
              'customValue' : undefined
            });
              isOk=PRJCLI_RefusExposition(id,"G");
              if(isOk != "ok")
                {
                  modulePRJCLI.find(".chargement").addClass("masque");
                  modulePRJCLI.find(".PRJCLI_error").removeClass("masque");
                  devlog("PRJCLI_RefusExposition Nok :"+isOk);
                }
              return false;
          });
        }
        else            //sinon, on cache le mobule et on prend en compte le refus d'exposition
        {
          //on cache le module de collecte
          modulePRJCLI.find(".PRJCLI_collecte").addClass("masque");
            //pour chaque collecte visible (en cas de multicollecte, on place le refus sur chaque élément de la collecte), on lance un refus d'exposition
          modulePRJCLI.find("fieldset:not(.masque)").each(function(){
            type=$(this).data("prjcli-type");
            niveau1=$(this).data("prjcli-niveau1");
            devlog("PRJCLI_RefusExposition("+id+",\"S\","+famille+","+type+","+niveau1+","+device+");");
            refusExpoRestans++;
            modulePRJCLI.data("prjcli-refusExpoRestans",refusExpoRestans)
              dataLayer.push({
              'event' : 'customEvent',
              'customCategory' : 'Module',
              'customAction' : 'Clic',
              'customLabel' : 'PRJCLI_RefusSpecifique#'+famille+'#'+niveau1,
              'customValue' : undefined
            });
              isOk=PRJCLI_RefusExposition(id,"S",famille,type,niveau1,device);
              if(isOk != "ok")
                {
                  //si KO on ne fait rien, car de toute façon on a déjà caché le module
                  modulePRJCLI.find(".chargement").addClass("masque");
                  modulePRJCLI.find(".PRJCLI_error").removeClass("masque");
                  devlog("PRJCLI_RefusExposition Nok :"+isOk);
                }
            });
            return false;
        }
        });*/
        //----------------------------------------------------------------------------------
        //FIN - gestion d'exposition ---------------------------------------------------------------
      }

      if (afficherModule == 1) {
        modulePRJCLI.querySelector(".PRJCLI_collecte").classList.remove("masque");
      }

      modulePRJCLI.querySelector(".chargement").classList.add("masque");
    }

    devlog("1840 PRJCLI_collecte Complete: " + JSON.stringify(retour));
    if (typeof PRJCLI_FinChargement === "function") {
      PRJCLI_FinChargement(); // External callback (optional)
    }
  }; //fin de la fct handlecomplete du WS de collecte


  return "ok";
} /*fin function PRJCLI_Collecte */

//#endregion

/*
#########################################
##### PRJCLI_RefusExposition #####
#########################################
Cette méthode met à disposition des modules de collecte la possibilité de positionner un refus d’exposition pour une nature de projet / centre d’intérêt (refus spécifique)  ou pour toutes les natures de projet / centre d’intérêt (refus global).
=================
Donnees en entree
=================
Id || Identifiant unique du module PRJCli. Permet de cibler le module si plusieurs modules sont insérés dans une page || Obligatoire
Type de refus || Type de refus : spécifique ou global || Valeurs possible : S/G || Obligatoire
Famille || Type de famille a renvoyer : projet ou centre d’interet || Valeurs possible : PJT/CIN || Obligatoire si refus spécifique
Type || Type de projet / centre d’interet || Valeurs possible : AIM/BES/INT/OPM/ATR/PJT/PRO || Obligatoire si refus spécifique
Niveau 1 || Code niveau 1 du projet / centre d’interet || Obligatoire si refus spécifique
Device || Device d’origine (application ou web) || Facultatif (Non exploité)

  =================
Donnees en sortie
=================
## code-retour ##
Code retour (base sur la codification HTTP) de la requete.
Les codes principalement utilises sont :
- 200 (donnees du module renvoyees)
- 204 (controles KO - pas de donnees renvoyees, ex. refus de reexposition positionne)
- 401 (tiers non authentifie) 403 : tiers mineur
- 5XX (erreur serveur, ex. communication mainframe impossible)
  ## libelle-retour ##
Libelle associe au code retour (« OK », « Erreur de serveur interne », …)
  */
/*
function PRJCLI_RefusExposition(id,typeRefus,famille,type,niveau1,device){
  //pointeur pour cibler le module PRJCLI
  var modulePRJCLI=document.getElementById(id);
  if(id === undefined || id === "")
  {
    if(document.getElementsByClassName("PRJCLI").length > 0)
      modulePRJCLI=document.getElementsByClassName("PRJCLI")[0];
    else
      return "Erreur : parametre Id non déclaré";
  }
  //obligatoire valeurs possible : S/G
  if(typeRefus === undefined || typeRefus === "" || (typeRefus != "S" && typeRefus != "G"))
    return "Erreur : parametre 'typeRefus' incorrect :"+typeRefus;
    //obligatoire si refus spécifique  valeurs possible : PJT/CIN
  if(typeRefus == "S" && (famille === undefined || famille === "" || (famille != "PJT" && famille != "CIN")))
    return "Erreur : parametre 'famille' incorrect :"+famille;
    //obligatoire si refus spécifique valeurs possible : AIM/BES/INT/OPM/ATR/PJT/PRO
  if(typeRefus == "S" && (type === undefined || type === "" || (type !="AIM" && type !="BES" && type !="INT" && type !="OPM" && type !="ATR" && type !="PJT" && type !="PRO")))
    return "Erreur : parametre 'type' incorrect :"+type;
    //obligatoire si refus spécifique
  if(typeRefus == "S" && (niveau1 === undefined || niveau1 === ""))
    return "Erreur : parametre 'niveau1' incorrect :"+niveau1;
    if(device === undefined || device === "")
    device="web"; //Obligatoire (valeur : app ou web)

  var requete=urlwebserviceRefusReexposition+"?typeRefus="+typeRefus+"&famille="+famille+"&type="+type+"&niveau1="+niveau1+"&device="+device;
  if(typeRefus == "G")
  {
    var requete=urlwebserviceRefusReexposition+"?typeRefus="+typeRefus;
    modulePRJCLI.setAttribute("data-prjcli-refusglobal","1");
  }
  devlog("PRJCLI_RefusExposition :" + requete);
      $.ajax({
      cache: false,
      type: 'Get',
      url: requete,
      async:true,
      dataType: 'json',
      context:modulePRJCLI,
      success: function(retour) {
          //$(this) correspond au contexte (context:modulePRJCLI) passé dans la requêtte Ajax
          var modulePRJCLI=$(this);
          devlog("PRJCLI_RefusExposition - Donnees renvoyees par le Webservice :" + retour);
            //Temporaire on parse le retour pour supprimer les "-" des noms de variables
          var strRetour = JSON.stringify(retour);
          strRetour = strRetour.replace(/\-/g,"\_");
          retour = JSON.parse(strRetour);
          //devlog("Retour parsé :" + retour);
          //---------------------------------------------------------------------------
            if(retour.code_retour != "200")
          {
            //si soucis
            //modulePRJCLI.find(".chargement").addClass("masque");
            modulePRJCLI.find(".PRJCLI_error").removeClass("masque");
            devlog('PRJCLI_RefusExposition - @Error code retour :'+retour.code_retour);
          }
          else //refus pris en compte
          {
            refusExpoRestans=modulePRJCLI.data("prjcli-refusExpoRestans");
            if(Number.isInteger(refusExpoRestans))
            {
              //devlog("refusExpoRestans"+id+" " + refusExpoRestans);
              refusExpoRestans--;
              modulePRJCLI.data("prjcli-refusExpoRestans",refusExpoRestans);
            }
            if(refusExpoRestans === 0 || modulePRJCLI.data("prjcli-refusglobal") == 1)
            {
              //modulePRJCLI.find(".chargement").addClass("masque");
              //modulePRJCLI.find(".PRJCLI_RE_Success").removeClass("masque");
            }
          }
        },
      error: function(xhr, status, errorThrown){
        var modulePRJCLI=$(this);
        modulePRJCLI.find(".chargement").addClass("masque");
          modulePRJCLI.find(".PRJCLI_error").removeClass("masque");
          devlog('PRJCLI_RefusExposition - @Error : '+errorThrown);
        devlog('PRJCLI_RefusExposition - @Status: '+status);
        devlog('PRJCLI_RefusExposition - @Status Text: '+xhr.statusText);
      },
      complete: function(data,res){
        devlog("PRJCLI_RefusExposition Complete "+data.responseText+" "+res);
        if (typeof PRJCLI_FinChargement === "function")
        {
          PRJCLI_FinChargement(); // Callback externe (optionnel)
        }
      }
    });
  return "ok";
}
*/

/*
#########################################
##### Main vanilla #####
#########################################
! Attention ! : le localStorage ne marche pas dans le contexte Apps, ça fait planter le script
  */
document.addEventListener("DOMContentLoaded", function () {

  //on recherche le contexte (Apps ou Desktop)
  //on cherche n'importe quel bloc prjcli pour regarder son attribut device (C11 = Desktop, C12 = Apps)
  var device = "C11";
  if (document.querySelector("section.PRJCLI")) {
    if (document.querySelector("section.PRJCLI").getAttribute("data-prjcli-device") !== undefined) {
      device = document.querySelector("section.PRJCLI").getAttribute("data-prjcli-device");
    }
  }

  if (debugApps) {
    document.querySelector("section.PRJCLI").insertAdjacentHTML("beforebegin", "<p style=\"word-break: break-all; margin:10px\">Ready</p>");
  }

  var i = 0;
  var isOk;
  //devlog("PRJCLI : Let's Go");

  //on regarde si l'on a pas une sauvegarde en attente (dans le cas ou l'on revient sur la page après authentification)
  //if(device == "C11" && getCookie("IdSes") != null && getCookie("SessionStart") != null && getCookie("SessionTimeout") != null && getVar("save") == 1)
  // retrait du getCookie IdDes car il est en http only et on ne peut donc pas le lire
  if (device == "C11" && getCookie("SessionStart") != null && getCookie("SessionTimeout") != null && getVar("save") == 1) {

    if (debugApps) {
      document.querySelector("section.PRJCLI").insertAdjacentHTML("beforebegin", "<p style=\"word-break: break-all; margin:10px\">Récupération Session</p>");
    }
    devlog("2006 récupération Session");
    //on réinitialise les paramètres d'URL en cas de rechargement de la page
    window.history.replaceState(null, null, window.location.pathname);

    var tabCollecteNonAuthentifiee = getLocalData('tabCollecteNonAuthentifiee');
    if (tabCollecteNonAuthentifiee != null) tabCollecteNonAuthentifiee = JSON.parse(tabCollecteNonAuthentifiee);

    //on vide le cookie et/ou le local Storage
    removeLocalData('tabCollecteNonAuthentifiee');

    //----------------------------------------------------------
    // Pour tous les modules PRJCLI de la page (simples ou multiples) on définni un id
    var sectionPrjCLi = document.querySelectorAll("section[data-prjcli]");
    var i = 0;
    sectionPrjCLi.forEach(function (section) {
      i++;
      //on vérifie que ce module n'a pas déjà été traité (dans ce cas son id est défini)
      if (section.getAttribute("id") === "" || section.getAttribute("id") === undefined || section.getAttribute("id") === null) {
        var id = "prjcli_" + i;
        section.setAttribute("id", id);
      }
    });
    //----------------------------------------------------------

    var sauvegardesRestantes = 0;

    tabCollecteNonAuthentifiee.forEach(function (obj) {
      var id = obj["id"];
      var famille = obj["famille"];
      var type = obj["type"];
      var niveau1 = obj["niveau1"];
      var niveau2 = obj["niveau2"];
      var dateEcheance = obj["dateEcheance"];
      var commentaire = obj["commentaire"];
      var device = obj["device"];
      var origine = obj["origine"];
      var version = obj["version"];
      var devise = obj["devise"];
      var montant = obj["montant"];

      devlog("2046 PRJCLI_Sauvegarde(" + id + "," + famille + "," + type + "," + niveau1 + "," + niveau2 + "," + dateEcheance + "," + commentaire + "," + device + "," + origine + "," + version + "," + devise + "," + montant + ");");
      var element = document.getElementById(id);
      if (element) {
        var formElement = element.querySelector(".PRJCLI_collecte form");
        formElement.classList.add("masque");
      }
      // modulePRJCLI.find(".PRJCLI_collecte form").before(modulePRJCLI.find(".chargement").prop('outerHTML'));
      // modulePRJCLI.find(".PRJCLI_collecte .chargement").removeClass("masque");

      if (typeof dataLayer != 'undefined') {
        dataLayer.push({
          'event': 'customEvent',
          'customCategory': 'Module',
          'customAction': 'Clic',
          'customLabel': 'PRJCLI_Transmettre#' + famille + '#' + niveau1,
          'customValue': undefined
        });
      }

      if (typeof trackEvent != 'undefined') {
        trackEvent({
          category: 'Module',
          action: 'Clic',
          label: 'PRJCLI_Transmettre#' + famille + '#' + niveau1
        });
      }
      //devlog("datalayer Clic PRJCLI_Transmettre", dataLayer);

      isOk = PRJCLI_Sauvegarde(id, famille, type, niveau1, niveau2, dateEcheance, commentaire, device, origine, version, devise, montant);
      sauvegardesRestantes++;
      element.setAttribute("data-prjcliSauvegardesRestantes", sauvegardesRestantes);

      devlog("2078 element", element, sauvegardesRestantes);
      if (isOk != "ok") {
        // modulePRJCLI.find(".PRJCLI_collecte form").addClass("masque");
        // modulePRJCLI.find(".PRJCLI_error").append('@Error : '+isOk);
        // modulePRJCLI.find(".PRJCLI_error").removeClass("masque");
        devlog("2083 PRJCLI_Collecte - Nok :" + isOk);
      }
    });
  } else {

    if (debugApps) {
      document.querySelector("section.PRJCLI").insertAdjacentHTML("beforebegin", "<p style=\"word-break: break-all; margin:10px\">Nouvelle Session</p>");
    }

    // le localStorage ne marche pas dans le contexte Apps, ça fait planter le script  C11 = Desktop, C12 = Apps)
    if (device == "C11") {
      //On vide le cookie et/ou le local Storage
      removeLocalData('tabCollecteNonAuthentifiee');
      removeLocalData('tabMessageProjets');
    }

    if (debugApps) {
      document.querySelector("section.PRJCLI").insertAdjacentHTML("beforebegin", "<p style=\"word-break: break-all; margin:10px\">Clean Session</p>");
    }

    // Pour tous les modules PRJCLI de la page (simples ou multiples)
    var sectionPrjCLi = document.querySelectorAll("section[data-prjcli]");
    i = 0;
    sectionPrjCLi.forEach(function (section) {
      i++;
      devlog('2108 section.getAttribute("id")', +section.getAttribute("id"));
      //on vérifie que ce module n'a pas déjà été traité (dans ce cas son id est défini)
      if (section.getAttribute("id") === "" || section.getAttribute("id") === undefined || section.getAttribute("id") === null) {
        var id = "prjcli_" + i;
        section.setAttribute("id", id);
        devlog('2113 section.getAttribute("id") set=>', section.getAttribute("id"));
        if (section.getAttribute("data-prjcli") == "CollecteAuthentifie" || section.getAttribute("data-prjcli") == "CollecteNonAuthentifie") {
          var modeCollecte = section.getAttribute("data-prjcli");
          //var modeCollecte = $(this).getAttribute('data-prjcli');

          devlog("2118 PRJCLI_Collecte(" + id + "," + modeCollecte + ")");
          if (debugApps) {
            document.querySelector("section.PRJCLI").insertAdjacentHTML("beforebegin", "<p style=\"word-break: break-all; margin:10px\">Call Collecte " + modeCollecte + "</p>");
          }

          //On lance un module de collecte
          isOk = PRJCLI_Collecte(id, modeCollecte);
          if (isOk != "ok") {
            section.classList.add("masque");
            section.insertAdjacentHTML("afterbegin", "<!-- Erreur :" + isOk + "-->");
            devlog("2128 Nok :" + isOk);
          }
        } else {
          section.classList.add("masque");
          devlog('2132 add masque');
        }
      } else {
        devlog('2135');
      }
    });
  }
});
//fin d'isolation du script
//  })()
//# sourceMappingURL=prjcliLib.js.map
//# sourceMappingURL=prjcliLib.js.map
